<template>
  <div>
    <div class="table-responsive col-lg-12">
      <table class="table table-striped table-bordered table-hover">
        <thead>
        <tr>
          <th>Toplist Name</th>
          <th>Website</th>
          <th>Outclicks 30 Days</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="toplist in toplists" :key="toplist.id" >
          <td>
            <router-link :to="'/advertisers/toplist/' + toplist.id" >{{ toplist.name }}</router-link>
          </td>
          <td>{{ toplist.website }}</td>
          <td></td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>

import { mapGetters } from 'vuex'
import { TOPLISTS_SET } from '../../../../store/mutation-types'
import axios from 'axios'

export default {
  computed: {
    ...mapGetters({
      toplists: 'getToplists'
    })
  },
  mounted () {
    this.getToplists()
  },
  methods: {
    async getToplists () {
      try {
        let resp = await axios.get('/advertisers/toplists')
        this.$store.commit(TOPLISTS_SET, resp.data)
      } catch (error) {
        this.$toastr.error('Failed loading affiliate company', error)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Advertisers/Toplists/List.vue